import { useSyncExternalStore } from 'react';

/**
 * ¿Está abierta la pregunta «¡Pieza lista! ¿Seguís o volvés a la nave?»? La abre `ShipPieceTracker`;
 * los avisos de primera vez de la charla (`ConversationCoachmarks`) la cuentan como un overlay más y
 * esperan (si no, salían encima y se comían el toque de «Volver a la nave», ronda del 20/10).
 */
let open = false;
const subs = new Set<() => void>();

export function setShipAskOpen(next: boolean): void {
  if (open === next) return;
  open = next;
  subs.forEach((f) => f());
}

export function useShipAskOpen(): boolean {
  return useSyncExternalStore(
    (fn) => {
      subs.add(fn);
      return () => {
        subs.delete(fn);
      };
    },
    () => open,
  );
}
